import ItemYoutubeVideo from 'components/Item/YoutubeVideo.js'
import React from 'react'
import { View } from 'components/View.js'
import { defineMessages } from 'react-intl'
import TextTitleLight from 'components/TextTitleLight/index.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { joinUpperCaseUnderscoreStringUtil } from 'packages/src'

const YOUTUBE_URL = 'https://www.youtube.com/embed/3Bcu16LdEUE?si=yUQ6bAfCUkh4V4Od'
const HEIGHT = '250px'

const messages = defineMessages({
  thePowerHybridChallengeInAction: {
    id: 'PowerHybridVideo.thePowerHybridChallengeInAction',
    defaultMessage: 'The PowerHybrid Challenge in action:'
  }
})

const ANALYTIC_EVENT = {
  PLAY_POWER_HYBRID_VIDEO: 'PLAY_POWER_HYBRID_VIDEO'
}

/**
 * @param analyticsEventPrefix
 * @returns {Element}
 * @constructor
 */
export default function PowerHybridVideo ({ analyticsEventPrefix }) {
  const intl = useIntl()

  const handleClick = () => {
    const event = joinUpperCaseUnderscoreStringUtil(analyticsEventPrefix, ANALYTIC_EVENT.PLAY_POWER_HYBRID_VIDEO)
    logEventAnalyticsUtil(
      event
    )
  }

  return (
    <View mb={2.5}>
      <TextTitleLight>
        {formatMessageIntlUtil(intl, messages.thePowerHybridChallengeInAction)}
      </TextTitleLight>

      <View mt>
        <ItemYoutubeVideo
          source={YOUTUBE_URL}
          height={HEIGHT}
          minHeight={HEIGHT}
          onClick={handleClick}
        />
      </View>
    </View>
  )
}
